import { SvgIconComponent } from '@ngneat/svg-icon';
import { Component, HostListener, inject, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { distinctUntilChanged, map } from 'rxjs/operators';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { GlobalService } from '../../../services/global.service';
import { crossYellowIcon } from '@svg/cross-yellow';
import { glovoWalletIcon } from '@svg/glovo-wallet';
import { glovoWalletMobileIcon } from '@svg/glovo-wallet-mobile';
import { registerSvgIcons } from '@shared/utils/svg-icons';


@Component({
  selector: 'app-glovo-wallet-modal',
  templateUrl: './glovo-wallet-modal.component.html',
  styleUrls: ['./glovo-wallet-modal.component.scss'],
  standalone: true,
  imports: [
    SvgIconComponent,
    CommonModule,
    TranslateModule,
    ],
})
export class GlovoWalletModalComponent implements OnInit {
  private readonly activeModal = inject(NgbActiveModal);
  private readonly globalService = inject(GlobalService);

  shopName: string = '';
  isMobile: boolean;

  constructor() {
    registerSvgIcons(crossYellowIcon, glovoWalletIcon, glovoWalletMobileIcon);
    this.onResize();
  }

  ngOnInit(): void {
    this.globalService.params$
      .pipe(
        map(p => p?.shopConfiguration?.name ?? ''),
        distinctUntilChanged()
      )
      .subscribe(name => {
        this.shopName = name;
      });
  }


  @HostListener('window:resize', ['$event'])
  onResize() {
    if (typeof window === 'undefined') return;
    this.isMobile = window.innerWidth <= 768;
  }
  close() {
    this.activeModal.close();
  }
}
